'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var IconX = require('@narvar/nth-bit-icon-x');
var style = require('../../utils/style.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthBitHeader = require('@narvar/nth-bit-header');
var StylelessButton = require('../StylelessButotn/StylelessButton.js');
var ActionButtonsContainer = require('./ActionButtonsContainer.js');
var Box = require('./Box/Box.js');
var Typography = require('../Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var IconX__default = /*#__PURE__*/_interopDefaultLegacy(IconX);

const DrawerContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1mdwpz8-0"
})(["display:flex;flex-direction:column;height:100dvh;"]);
const DismissContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1mdwpz8-1"
})(["display:flex;justify-content:flex-end;padding:0.5rem;"]);
const Drawer = _ref => {
  let {
    children,
    onDismiss,
    dismissText
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(DrawerContainer, null, /*#__PURE__*/React__default["default"].createElement(DismissContainer, null, /*#__PURE__*/React__default["default"].createElement(StylelessButton.StylelessButton, {
    onClick: onDismiss
  }, /*#__PURE__*/React__default["default"].createElement(IconX__default["default"], {
    "aria-label": dismissText
  }))), children);
};
const DrawerHeader = _ref2 => {
  let {
    title,
    subtitle
  } = _ref2;
  if (!title) return null;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h1"
  }, title), subtitle && /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, subtitle));
};
const DrawerContent = styled__default["default"].div.withConfig({
  componentId: "sc-1mdwpz8-2"
})(["overflow:scroll;flex:1 0 0;padding:1.5rem;"]);
const DrawerFooterSectionRoot = _ref3 => {
  let {
    children
  } = _ref3;
  const {
    panelcontainerNoneNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      borderTopWidth: style.getBorderWidth(panelcontainerNoneNone),
      borderTopColor: style.getBorderColor(panelcontainerNoneNone),
      borderTopStyle: 'solid',
      padding: '1rem'
    }
  }, children);
};
const DrawerFooterSection = nthHookTheme.withThemeProvider(DrawerFooterSectionRoot, {
  themeTokens: ['panelcontainerNoneNone']
});
const DrawerActions = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React__default["default"].createElement(DrawerFooterSection, null, /*#__PURE__*/React__default["default"].createElement(ActionButtonsContainer["default"], null, children));
};
const DrawerFooter = styled__default["default"].div.withConfig({
  componentId: "sc-1mdwpz8-3"
})([""]);

exports.Drawer = Drawer;
exports.DrawerActions = DrawerActions;
exports.DrawerContainer = DrawerContainer;
exports.DrawerContent = DrawerContent;
exports.DrawerFooter = DrawerFooter;
exports.DrawerFooterSection = DrawerFooterSection;
exports.DrawerHeader = DrawerHeader;
